import { createContext, useContext, useReducer } from "react";
import appReducer from "reducers/app.reducer";

export const AppContext = createContext(null);

const initialState = {
    isSidebarOpen: true
}

const AppProvider = ({
    children
}) => {
    const [state, dispatch] = useReducer(appReducer, initialState);
    return (
        <AppContext.Provider
            value={{
                ...state,
                dispatch
            }}
        >
            {children}
        </AppContext.Provider>
    )
}

export default AppProvider;